module.exports = __webpack_public_path__ + "static/media/b5-white-english.eb9a4bef.png";